<template><!--个人中心》我的钱包》用券记录-->
    <div class="myBalance">
        <div class="mybal-box" style="border-bottom: 1px solid #f1f1f1;">
            <div class="dis">
                <div class="mybal-xian"></div>
                <div class="mybal-p">我的账号：{{userObj.phone}}</div>
            </div>
            <div class="dis-between">
                <div class="mybal-wid dis" style="height:auto">
                    <img class="mybal-img" src="../../../assets/image/iocn/TX.png" />
                    <div style="margin:auto 0 auto 11px">
                        <div v-if="vipCard">
                            <div class="" style="width: 131px;">
                                <img src="../../../assets/image/iocn/huiyuan2.png" />
                                <div class="mybal-p2" style="width:60%;">{{userObj.vipCard}}</div>
                            </div>
                            <!-- <div class="mybal-wid2" style="width:180px">会员积分 {{myBalance.tokenmoney}}</div> -->
                        </div>
                        <div v-else>
                            <div
                                class="index-icon-box-p"
                                @click="openVipClick"
                            >开通VIP</div>
                            <div class="index-box-p">{{userObj.phone}}</div>
                        </div>
                    </div>
                </div>

                <div style="width:71%">
                    <div class="mybal-box" style="padding:0 0;margin-top:24px">
                        <div class="dis-between" style="background: #F1F1F1;height: 56px;padding:0 24px;">
                            <div class="mybal-p3">通用券额度：<span style="color:#11D165">￥{{myBalance.generalvolume}}</span></div>
                            <div class="dis-cen" v-if="title_act == 1">
                                <div class="uc-botton dis-cen" style="border: 1px solid #23C959"><div class="uc-botton-act"></div></div>
                            </div>
                            <div class="dis-cen" v-else @click="titleClick(1)">
                                <div class="uc-botton"></div>
                            </div>
                        </div>
                    </div>
                    <div class="mybal-box" style="padding:0 0;margin-top:16px">
                        <div class="dis-between" style="background: #F1F1F1;height: 56px;padding:0 24px;">
                            <div class="mybal-p3">消费券额度：<span style="color:#11D165">￥{{myBalance.vouchers}}</span></div>
                            <div class="dis-cen" v-if="title_act == 2">
                                <div class="uc-botton dis-cen" style="border: 1px solid #23C959"><div class="uc-botton-act"></div></div>
                            </div>
                            <div class="dis-cen" v-else @click="titleClick(2)">
                                <div class="uc-botton"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mybal-box" style="margin-top:24px">
            <div class="dis-between">
                <div class="dis">
                    <div class="mybal-xian"></div>
                    <div class="mybal-p" v-if="title_act == 1">通用券记录</div>
                    <div class="mybal-p" v-else-if="title_act == 2">消费券记录</div>
                </div>
                <div class="dis">
                    <div class="myBalance-picker">
                        <el-date-picker
                            v-model="value2"
                            type="datetimerange"
                            :picker-options="pickerOptions"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right"
                            @change = "pickerReadClick"
                        ></el-date-picker>
                    </div>

                </div>
            </div>
        </div>

        <div class="mybal-box" style="padding:0 24px 24px 24px">
            <div class="mybal-wid3 dis-between">
                <div class="mybal-title-wid" style="width:20%">时间</div>
                <div class="mybal-title-wid" style="text-align:center">订单号</div>
                <div class="mybal-title-wid4" style="width:26%">类型</div>
                <div class="mybal-title-wid4" style="width:14%">交易值</div>
                <div class="mybal-title-wid4" style="width:15%"><span v-if="title_act == 1">当前通用券</span><span v-else-if="title_act == 2">当前消费券</span></div>
            </div>
            <div v-if="listData.length > 0">
                <div v-for="(item, index) in listData" :key="index">
                    <div class="mybal-wid4 dis-between">
                        <div class="mybal-title-wid" style="width:20%">{{item.addTime}}</div>
                        <div class="mybal-title-wid" style="text-align:center"><span>{{item.orderNo}}</span></div>
                        <div class="mybal-title-wid4" style="width:26%">{{item.wayName}}</div>
                        <div class="mybal-title-wid4" style="width:14%"><span v-if="title_act == 1">{{item.generalvolume}}</span><span v-else-if="title_act == 2">{{item.vouchers}}</span></div>
                        <div class="mybal-title-wid4" style="width:15%"><div><span v-if="title_act == 1">{{item.currentgeneralvolume}}</span><span v-else-if="title_act == 2">{{item.currentvouchers}}</span></div></div>
                    </div>
                </div>
            </div>
            <div v-else class="mybal-no-box">暂无数据</div>
        </div>

        <div class="list-page dis-end myBalance-pagination" style="margin-top:24px">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[100, 200, 300, 400]"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="totalLength"
            >
            </el-pagination>
        </div>

    </div>
</template>

<style scoped>
    .myBalance-picker >>> .el-input__inner {height:32px;line-height: 32px}
    .myBalance-picker >>> .el-input__icon{height:auto}
    .myBalance-picker >>> .el-date-editor .el-range-separator{height:32px}
    .myBalance-pagination >>> .el-pagination .btn-prev {margin-right: 5px;}
    .mybal-title-wid4{width: 10%;text-align: center;}
    .mybal-color-act-p{color:#11D165;}.mybal-box-list-bac{background-color: #f5f5f5;}.mybal-color-act-p2{color:#f56c6c}
    .mybal-box-list-bac2{background-color: #fdf6ec;}
    .mybal-box-list-bac3{background-color: #fef0f0;}
    .mybal-box-list-bac4{background-color: #f5f5f5;}
    .uc-botton{width: 28px;height: 28px;border: 1px solid #333333;border-radius: 30px;}
    .uc-botton-act{width: 18px;height: 18px;background: #23C959;border-radius: 30px;}
</style>

<script>
    export default
    {
        name: 'myBalance',
        props: { parentName: { type: Object } },
        data()
        {
            return {
                title_act: 1,
                myBalance: {},
                userObj: {},
                listData: [],
                vipCard: '',
                pickerOptions: {
                    shortcuts: [
                        {
                            text: "最近一周",
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 7
                                )
                                picker.$emit("pick", [start, end])
                            }
                        },
                        {
                            text: "最近一个月",
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 30
                                )
                                picker.$emit("pick", [start, end])
                            }
                        },
                        {
                            text: "最近三个月",
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 90
                                )
                                picker.$emit("pick", [start, end])
                            }
                        }
                    ]
                },
                value2: "",
                DateStart: '',
                DateEnd: '',
                pageNo: 1,
                totalPage: 0, //总页数
                pageSize: 10,
                totalLength: 0, //总条数
                currentPage: 1,

                // nowPage: 1, //当前页数
                // productPage: 10, //总页数
                // pageIndex: 0, //页数索引
                //+--------------------------------------------------------
                bol: false,
            };
        },
        created()
        {
            this.vipCard = localStorage.getItem( 'vipCard' ) != 'null' ? localStorage.getItem( 'vipCard' ) : ''
            this.userObj = JSON.parse( localStorage.getItem( 'loginData2' ) )
            this.title_act = localStorage.getItem( 'titleActValue' ) ? localStorage.getItem( 'titleActValue' ) : 1
            localStorage.removeItem('titleActValue')
            this.titleClick(this.title_act)
            if (this.title_act !== 1) this.getBalance()
        },
        methods:
        {
            openVipClick()
            {
                localStorage.setItem( 'divType', 1 );
                this.$router.push( { path: '/regist?num=1' } )
            },
            divClick(val) {
                this.closeaddress(val)
            },
            pickerReadClick() {
                if (this.value2 == null) {
                    this.titleClick(this.title_act)
                    return
                }
                this.pageNo = 1
                this.DateStart = this.formatDate(this.value2[0])
                this.DateEnd = this.formatDate(this.value2[1])
                this.titleClick(this.title_act, 1)
            },
            titleClick(val, type= '') {
                this.title_act = val
                if (!type) {
                    this.pageNo = this.currentPage = 1
                    this.totalPage = this.totalLength = 0
                    this.value2 = ''
                    this.DateStart = ''
                    this.DateEnd = ''
                    this.listData = []
                }
                if (val == 1) {
                    this.getBalance()
                    this.getGeneralVolumeList()
                } else if (val == 2) {
                    this.GetvouchersList()
                }
            },
            getBalance() {
                this.$api.order.UserBalances().then(res => {
                    if (res.data.code == 0) {
                        this.myBalance = res.data.result
                    } else {
                        let name = res.data.message
                        this.checkTips(name, "warning")
                    }
                })
            },
            getGeneralVolumeList()
            {
                let params = {
                    PageNo: this.pageNo,
                    PageSize: this.pageSize,
                    Params:
                    {
                        DateStart: this.DateStart,
                        DateEnd: this.DateEnd
                    }
                }
                this.$api.product.GetUserGeneralVolumeLog( params ).then( res =>
                {
                    this.$loading().close();
                    this.listData = res.data.result.data
                    // +---------------------------------------
                    let totalcount = res.data.result.totalCount;
                    this.totalLength = totalcount;
                    // 计算一共有几页
                    this.totalPage = Math.ceil( totalcount / this.pageSize );
                    // 计算得0时设置为1
                    this.totalPage = this.totalPage == 0 ? 1 : this.totalPage;
                } )
            },
            GetvouchersList()
            {
                let params = {
                    PageNo: this.pageNo,
                    PageSize: this.pageSize,
                    Params:
                    {
                        DateStart: this.DateStart,
                        DateEnd: this.DateEnd
                    }
                }
                this.$api.order.GetUserVouchersLog(params).then(res => 
                {
                    this.$loading().close();
                    this.listData = res.data.result.data
                    // +---------------------------------------
                    let totalcount = res.data.result.totalCount;
                    this.totalLength = totalcount;
                    // 计算一共有几页
                    this.totalPage = Math.ceil( totalcount / this.pageSize );
                    // 计算得0时设置为1
                    this.totalPage = this.totalPage == 0 ? 1 : this.totalPage;
                } )
            },
            handleSizeChange( val )
            {
                console.log( `每页 ${val} 条` );
            },
            handleCurrentChange( val )
            {
                this.pageNo = val;
                this.titleClick(this.title_act, 1)
            },
            checkTips( name, type )
            { //用户提示
                this.$message(
                {
                    message: name,
                    type: type
                } )
            },
            // +-------------------------
            //将中国标准时间转换为年月日格式
            formatTen(num) { 
                return num > 9 ? (num + "") : ("0" + num); 
            },
            formatDate(date) { 
                var year = date.getFullYear(); 
                var month = date.getMonth() + 1; 
                var day = date.getDate(); 
                var hour = date.getHours(); 
                var minute = date.getMinutes(); 
                var second = date.getSeconds(); 
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day)+ " " + this.formatTen(hour)+ ":" + this.formatTen(minute)+ ":" + this.formatTen(second); 
            },
            // +--------------------------------------
            closeaddress(val)
            {
                this.$emit( 'childFn', val )
            }

        }
    }
</script>